import React, { useState, useEffect } from "react";
import { useAuth } from "oidc-react";

const IdleTimeoutWrapper = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(true);
    const { signOut, signOutRedirect, userData } = useAuth();

    useEffect(() => {
        let logoutTimer = null;

        const resetTimer = () => {
            if (logoutTimer) {
                clearTimeout(logoutTimer);
            }

            logoutTimer = setTimeout(() => {
                handleLogout();
            }, 15 * 60 * 1000);
        };

        const handleLogout = async () => {
            setIsLoggedIn(false);
            window.localStorage.clear();
            await signOutRedirect();
        };

        // Menetapkan event listener pada setiap kejadian mousemove atau keydown
        document.addEventListener("mousemove", resetTimer);
        document.addEventListener("keydown", resetTimer);

        // Membersihkan event listener saat komponen dibongkar
        return () => {
            document.removeEventListener("mousemove", resetTimer);
            document.removeEventListener("keydown", resetTimer);
        };
    }, []);

    return <div>{isLoggedIn ? children : <h1>Anda sudah logout!</h1>}</div>;
};

export default IdleTimeoutWrapper;
